export const VENUE_DEPARTMENTS = [
  "Department of Chemistry & Biochemistry (DST-FIST Sponsored)",
  "Department of Energy and Environment (DST-FIST Sponsered)",
  "Department of Mathematics",
  "Department of Physics & Materials Science",
  "L. M. Thapar School of Management",
  "School of Humanities & Social Sciences",
  "Thapar School of Liberal Arts & Sciences (TSLAS)",
  "Basic & Engineering Sciences (Dera Bassi Campus)",
  "Chemical Engineering",
  "Civil Engineering",
  "Computer Science & Engineering",
  "Department of Biotechnology",
  "Distance Education (DDE)",
  "Electrical & Instrumentation Engineering",
  "Electronics & Communication Engineering",
  "Mechanical Engineering Department",
  "Alumni Relations link",
  "Center for Industrial Liaison & Placement",
  "Center of Excellence in Emerging Materials",
  "Central Workshop",
  "Centre for Training & Development",
  "Centre of Excellence Data Science and Artificial Intelligence",
  "Centre of Information and Technology Management",
  "Disability Resource Centre",
  "Experiential Learning Centre",
  "Nava Nalanda Central Library",
  "Science & Technology Entrepreneur's Park",
  "Thapar Learn",
  "TIFAC Core In Agro Industrial BioTechnology",
  "Venture Lab",
  "CILP Office",
  "ProVC Office",
  "Director Office",
  "DoSA Office",
  "DoAA Office",
  "DoRSP Office",
];
